module.exports = __webpack_public_path__ + "media/src/assets/Images/DownloadArrowButton-bcc704ef564c4cf80a19ff242b702fbd.svg";